var _filter, _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgS1A3Ele(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 1190,
    viewBox: "0 0 842 1190",
    width: 842,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "a",
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 290.497,
    width: 917.361,
    x: -38.2233,
    y: 925.006
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9.17361
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 33.6366
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.92549 0 0 0 0 0.494118 0 0 0 0 0.694118 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_2747_160269"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2747_160269",
    mode: "normal",
    result: "shape"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h842v1190h-842z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#fae9f2",
    height: 155.951,
    rx: 62.6863,
    width: 782.815,
    x: 29.0498,
    y: 983.106
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#ea0d8b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m46.5155 1019.28c-6.1868.12-10.6244-3.86-10.7425-9.96-.0816-4.22 1.2317-9.04 5.2728-18.276l5.1154-11.873c.4049-.88 1.2373-1.478 2.2216-1.497l6.8899-.133c1.2654-.025 1.9854.833 1.5888 2.149l-6.0883 19.742c3.6867 1.528 6.1446 4.968 6.229 9.328.1153 5.96-4.1593 10.4-10.4867 10.52zm26.8564-.52c-6.1868.12-10.6244-3.86-10.7426-9.96-.0815-4.22 1.2318-9.039 5.2729-18.276l5.1153-11.873c.405-.88 1.2374-1.478 2.2217-1.497l6.8898-.133c1.2655-.025 1.9854.834 1.5889 2.15l-6.0884 19.742c3.6868 1.527 6.1447 4.967 6.229 9.327.1153 5.96-4.1592 10.4-10.4866 10.52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m793.381 1114.8c6.187-.12 10.625 3.86 10.743 9.97.081 4.21-1.232 9.03-5.273 18.27l-5.115 11.87c-.405.88-1.238 1.48-2.222 1.5l-6.89.13c-1.265.03-1.985-.83-1.589-2.15l6.089-19.74c-3.687-1.53-6.145-4.97-6.229-9.33-.116-5.96 4.159-10.4 10.486-10.52zm-26.856.52c6.187-.12 10.624 3.86 10.742 9.96.082 4.22-1.231 9.04-5.272 18.28l-5.116 11.87c-.405.88-1.237 1.48-2.221 1.5l-6.89.13c-1.266.03-1.986-.83-1.589-2.15l6.088-19.74c-3.687-1.53-6.144-4.97-6.229-9.33-.115-5.96 4.159-10.4 10.487-10.52z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS1A3Ele);
export default __webpack_public_path__ + "static/media/S1_A3_ELE.4dbfff3ed525b1e64b4310508c553cb4.svg";
export { ForwardRef as ReactComponent };